import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-swal',
  template: '', // Empty template as modal is opened imperatively
})
export class SwalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
